export const icebergSilverData = {
  took: 5,
  timed_out: false,
  _shards: {
    total: 22,
    successful: 22,
    skipped: 20,
    failed: 0,
  },
  hits: {
    total: {
      value: 6,
      relation: 'eq',
    },
    max_score: null,
    hits: [
      {
        _index: 'table_search_index',
        _id: '9d0a653f-2511-4a3f-8650-320c3f08f584',
        _score: null,
        _source: {
          databaseSchema: {
            deleted: false,
            displayName: 'g_turbo',
            name: 'g_turbo',
            description:
              '<ul class="om-list-disc"><li class="om-leading-normal"><p>가디원 터보 Iceberg 표준화 &amp; 정제를 거친 데이터 마트</p></li></ul><p></p>',
            id: '02c1fd51-c6cd-45a8-9e52-fca1044cee0a',
            type: 'databaseSchema',
            fullyQualifiedName: 'silver-iceberg.silver.g_turbo',
          },
          serviceType: 'Iceberg',
          displayName: 'gsp_ecms1_waveform_preprocessed',
          schemaDefinition: null,
          description:
            '<ul class="om-list-disc"><li class="om-leading-normal"><p>GSP ECMS1 대상 표준화-정제를 거친 진동 raw 데이터</p></li></ul><p></p>',
          owners: [
            {
              deleted: false,
              displayName: 'DI',
              inherited: true,
              name: 'DI',
              description:
                '<ul class="om-list-disc"><li class="om-leading-normal"><p>데이터 과학자, 분석가 소속 팀</p></li></ul><p></p>',
              id: '3b28a5be-4517-48f0-84f4-01ae147493bd',
              type: 'team',
              fullyQualifiedName: 'DI',
            },
          ],
          tierSources: {},
          fqnHash:
            '655f8a2d535e8834f62cae4d39557265.97f014516561ef487ec368d6158eb3f4.5df9be687e674cc4273916ac1fa9a834.2eee204fc5d8da7e5f91c43d5565a4d6',
          customMetrics: [],
          tableType: 'Regular',
          database: {
            deleted: false,
            displayName: 'silver',
            name: 'silver',
            id: '6bcf4d50-3c8d-4bfe-a60f-75dbee8b6478',
            type: 'database',
            fullyQualifiedName: 'silver-iceberg.silver',
          },
          descriptionStatus: 'COMPLETE',
          columnNames: [
            'acquisition_time',
            'enterprise',
            'area',
            'site',
            'process',
            'unit',
            'component',
            'component_id',
            'bearing_name',
            'sensor_x_name',
            'sensor_y_name',
            'rotation_direction',
            'vibration_x',
            'vibration_y',
            'x_peak_to_peak',
            'y_peak_to_peak',
            'vibration_type',
            'sample_size',
            'sample_rate',
            'rpm',
            'scale_factor',
          ],
          tier: null,
          totalVotes: 0,
          usageSummary: {
            date: '2026-03-26',
            weeklyStats: {
              percentileRank: 0,
              count: 0,
            },
            monthlyStats: {
              percentileRank: 0,
              count: 0,
            },
            dailyStats: {
              percentileRank: 0,
              count: 0,
            },
          },
          id: '9d0a653f-2511-4a3f-8650-320c3f08f584',
          columnDescriptionStatus: 'INCOMPLETE',
          upstreamEntityRelationship: [],
          updatedAt: 1762145330637,
          columnNamesFuzzy:
            'acquisition_time enterprise area site process unit component component_id bearing_name sensor_x_name sensor_y_name rotation_direction vibration_x vibration_y x_peak_to_peak y_peak_to_peak vibration_type sample_size sample_rate rpm scale_factor',
          descriptionSources: {
            Manual: 21,
          },
          updatedBy: 'admin',
          entityType: 'table',
          domains: [
            {
              displayName: 'test_product',
              name: 'test_product',
              description: '<p>test_product</p>',
              id: 'abd12bca-4d04-4d85-9cc3-5ddc74c643e2',
              type: 'domain',
              fullyQualifiedName: 'test-production.test_process.test_product',
            },
          ],
          dataProducts: [],
          fullyQualifiedName: 'silver-iceberg.silver.g_turbo.gsp_ecms1_waveform_preprocessed',
          version: 1.4,
          queries: [],
          certification: {
            tagLabel: {
              tagFQN: 'Certification.Silver',
              name: 'Silver',
              labelType: 'Manual',
              description: 'Silver certified Data Asset',
              style: {
                color: '#B8B8B8',
                iconURL: 'SilverCertification.svg',
              },
              source: 'Classification',
              state: 'Confirmed',
            },
          },
          tags: [
            {
              tagFQN: 'Equipment Type.터빈',
              name: '터빈',
              displayName: '터빈',
              description: '터빈 설비 관련 데이터',
              source: 'Classification',
              labelType: 'Manual',
              state: 'Confirmed',
            },
            {
              tagFQN: 'Equipment Type.CNC_Lathe',
              name: 'CNC_Lathe',
              displayName: 'CNC Lathe',
              description: 'CNC 선반 설비 관련 데이터',
              source: 'Classification',
              labelType: 'Manual',
              state: 'Confirmed',
            },
          ],
          terms: [
            {
              id: 'term-vibration',
              type: 'glossaryTerm',
              name: 'Vibration',
              displayName: '진동',
              fullyQualifiedName: 'Manufacturing.Vibration',
              deleted: false,
            },
            {
              id: 'term-preprocessing',
              type: 'glossaryTerm',
              name: 'Preprocessing',
              displayName: '전처리',
              fullyQualifiedName: 'DataManagement.Preprocessing',
              deleted: false,
            },
          ],
          sourceHash: '9998378fc0b198fe3aba19a418aa786f',
          followers: [],
          deleted: false,
          service: {
            deleted: false,
            displayName: 'silver-iceberg',
            name: 'silver-iceberg',
            description:
              '<ul class="om-list-disc"><li class="om-leading-normal"><p>Silver Tier Iceberg</p></li></ul><p></p>',
            id: 'c3c00286-ae2f-4655-a827-a39a02303b36',
            type: 'databaseService',
            fullyQualifiedName: 'silver-iceberg',
          },
          name: 'gsp_ecms1_waveform_preprocessed',
          processedLineage: false,
          tablePartition: {
            columns: [
              {
                intervalType: 'COLUMN-VALUE',
                columnName: 'sensor_x_name',
              },
              {
                intervalType: 'COLUMN-VALUE',
                columnName: 'sensor_y_name',
              },
            ],
          },
          tagSources: {},
          upstreamLineage: [
            {
              createdAt: 1772155672293,
              updatedBy: 'jaejun.lee',
              fromEntity: {
                id: 'c71b5d60-f057-404b-aba7-e6e6d6f385ed',
                fullyQualifiedName: 'bronze-iceberg.bronze.g_turbo.gsp_ecms1_bearings1',
                type: 'table',
                fqnHash:
                  'd3e099f4de5c79f8999f7fccaf37c881.cab7e764b30007514145eaf2f6a7ed0f.5df9be687e674cc4273916ac1fa9a834.ae65a7f74d9dd2785698b81c39b3aedb',
              },
              createdBy: 'jaejun.lee',
              docId:
                'bronze-iceberg.bronze.g_turbo.gsp_ecms1_bearings1--->silver-iceberg.silver.g_turbo.gsp_ecms1_waveform_preprocessed',
              docUniqueId: 'c71b5d60-f057-404b-aba7-e6e6d6f385ed--->9d0a653f-2511-4a3f-8650-320c3f08f584',
              source: 'Manual',
              updatedAt: 1772155672293,
            },
            {
              createdAt: 1772155676064,
              updatedBy: 'jaejun.lee',
              fromEntity: {
                id: 'd9175052-b735-4a43-a6e5-720bb62dc324',
                fullyQualifiedName: 'bronze-iceberg.bronze.g_turbo.gsp_ecms1_trend',
                type: 'table',
                fqnHash:
                  'd3e099f4de5c79f8999f7fccaf37c881.cab7e764b30007514145eaf2f6a7ed0f.5df9be687e674cc4273916ac1fa9a834.747f427d015adb9dbc5389bef5b79876',
              },
              createdBy: 'jaejun.lee',
              docId:
                'bronze-iceberg.bronze.g_turbo.gsp_ecms1_trend--->silver-iceberg.silver.g_turbo.gsp_ecms1_waveform_preprocessed',
              docUniqueId: 'd9175052-b735-4a43-a6e5-720bb62dc324--->9d0a653f-2511-4a3f-8650-320c3f08f584',
              source: 'Manual',
              updatedAt: 1772155676064,
            },
            {
              createdAt: 1772155673792,
              updatedBy: 'jaejun.lee',
              fromEntity: {
                id: 'fb93e3f5-d337-44de-8e07-cd528444c40c',
                fullyQualifiedName: 'bronze-iceberg.bronze.g_turbo.gsp_ecms1_chart',
                type: 'table',
                fqnHash:
                  'd3e099f4de5c79f8999f7fccaf37c881.cab7e764b30007514145eaf2f6a7ed0f.5df9be687e674cc4273916ac1fa9a834.a9b2f5c53c3e7eb88ce5e1fe4c614b60',
              },
              createdBy: 'jaejun.lee',
              docId:
                'bronze-iceberg.bronze.g_turbo.gsp_ecms1_chart--->silver-iceberg.silver.g_turbo.gsp_ecms1_waveform_preprocessed',
              docUniqueId: 'fb93e3f5-d337-44de-8e07-cd528444c40c--->9d0a653f-2511-4a3f-8650-320c3f08f584',
              source: 'Manual',
              updatedAt: 1772155673792,
            },
          ],
          locationPath: null,
          fqnParts: [
            'g_turbo',
            'silver-iceberg.silver',
            'silver.g_turbo.gsp_ecms1_waveform_preprocessed',
            'silver-iceberg.silver.g_turbo',
            'silver.g_turbo',
            'silver',
            'silver-iceberg.silver.g_turbo.gsp_ecms1_waveform_preprocessed',
            'silver-iceberg',
            'g_turbo.gsp_ecms1_waveform_preprocessed',
          ],
        },
        sort: [0],
      },
      {
        _index: 'table_search_index',
        _id: '45ae3a26-7cce-45d6-abea-45c9cd8d43c2',
        _score: null,
        _source: {
          databaseSchema: {
            deleted: false,
            displayName: 'g_turbo',
            name: 'g_turbo',
            description:
              '<ul class="om-list-disc"><li class="om-leading-normal"><p>가디원 터보 Iceberg 표준화 &amp; 정제를 거친 데이터 마트</p></li></ul><p></p>',
            id: '02c1fd51-c6cd-45a8-9e52-fca1044cee0a',
            type: 'databaseSchema',
            fullyQualifiedName: 'silver-iceberg.silver.g_turbo',
          },
          serviceType: 'Iceberg',
          displayName: 'hanwha_impact_config',
          schemaDefinition: null,
          description:
            '<ul class="om-list-disc"><li class="om-leading-normal"><p>한화 임팩트 대상 표준화-정제를 거친 진단 config</p></li></ul><p></p>',
          owners: [
            {
              deleted: false,
              displayName: 'DI',
              inherited: true,
              name: 'DI',
              description:
                '<ul class="om-list-disc"><li class="om-leading-normal"><p>데이터 과학자, 분석가 소속 팀</p></li></ul><p></p>',
              id: '3b28a5be-4517-48f0-84f4-01ae147493bd',
              type: 'team',
              fullyQualifiedName: 'DI',
            },
          ],
          tierSources: {},
          fqnHash:
            '655f8a2d535e8834f62cae4d39557265.97f014516561ef487ec368d6158eb3f4.5df9be687e674cc4273916ac1fa9a834.861e82fef28c472e077018b2d6d37581',
          customMetrics: [],
          tableType: 'Regular',
          database: {
            deleted: false,
            displayName: 'silver',
            name: 'silver',
            id: '6bcf4d50-3c8d-4bfe-a60f-75dbee8b6478',
            type: 'database',
            fullyQualifiedName: 'silver-iceberg.silver',
          },
          descriptionStatus: 'COMPLETE',
          columnNames: [
            'id',
            'sensor_x_name',
            'sensor_y_name',
            'neighbor_id',
            'sensor_x',
            'sensor_y',
            'asset_sequence',
            'vib_threshold_h',
            'vib_threshold_hh',
            'process_temperature',
            'temperature_threshold_h',
            'temperature_threshold_hh',
            'critical_speed',
            'rated_speed',
            'source_unit',
          ],
          tier: null,
          totalVotes: 0,
          usageSummary: {
            date: '2026-03-26',
            weeklyStats: {
              percentileRank: 0,
              count: 0,
            },
            monthlyStats: {
              percentileRank: 0,
              count: 0,
            },
            dailyStats: {
              percentileRank: 0,
              count: 0,
            },
          },
          id: '45ae3a26-7cce-45d6-abea-45c9cd8d43c2',
          columnDescriptionStatus: 'INCOMPLETE',
          upstreamEntityRelationship: [],
          updatedAt: 1761898977467,
          columnNamesFuzzy:
            'id sensor_x_name sensor_y_name neighbor_id sensor_x sensor_y asset_sequence vib_threshold_h vib_threshold_hh process_temperature temperature_threshold_h temperature_threshold_hh critical_speed rated_speed source_unit',
          descriptionSources: {
            Manual: 15,
          },
          updatedBy: 'jaejun.lee',
          entityType: 'table',
          domains: [
            {
              displayName: 'test-production',
              inherited: true,
              name: 'test-production',
              description: '<pre><code>test-production</code></pre><p></p>',
              id: '1138eeb2-02fd-49d2-95fd-9f053348e281',
              type: 'domain',
              fullyQualifiedName: 'test-production',
            },
          ],
          dataProducts: [],
          fullyQualifiedName: 'silver-iceberg.silver.g_turbo.hanwha_impact_config',
          version: 0.3,
          queries: [],
          certification: {
            tagLabel: {
              tagFQN: 'Certification.Silver',
              name: 'Silver',
              labelType: 'Manual',
              description: 'Silver certified Data Asset',
              style: {
                color: '#B8B8B8',
                iconURL: 'SilverCertification.svg',
              },
              source: 'Classification',
              state: 'Confirmed',
            },
          },
          tags: [
            {
              tagFQN: 'Equipment Type.Furnace',
              name: 'Furnace',
              displayName: 'Furnace',
              description: '용광로 설비 관련 데이터',
              source: 'Classification',
              labelType: 'Manual',
              state: 'Confirmed',
            },
            {
              tagFQN: 'Equipment Type.사출기',
              name: '사출기',
              displayName: '사출기',
              description: '사출 성형 설비 관련 데이터',
              source: 'Classification',
              labelType: 'Manual',
              state: 'Confirmed',
            },
          ],
          terms: [
            {
              id: 'term-metadata',
              type: 'glossaryTerm',
              name: 'Metadata',
              displayName: '메타데이터',
              fullyQualifiedName: 'DataManagement.Metadata',
              deleted: false,
            },
          ],
          sourceHash: '19d62670cbe593a24cde02e5c063e2fd',
          followers: [],
          deleted: false,
          service: {
            deleted: false,
            displayName: 'silver-iceberg',
            name: 'silver-iceberg',
            description:
              '<ul class="om-list-disc"><li class="om-leading-normal"><p>Silver Tier Iceberg</p></li></ul><p></p>',
            id: 'c3c00286-ae2f-4655-a827-a39a02303b36',
            type: 'databaseService',
            fullyQualifiedName: 'silver-iceberg',
          },
          name: 'hanwha_impact_config',
          processedLineage: false,
          tablePartition: {
            columns: [
              {
                intervalType: 'COLUMN-VALUE',
                columnName: 'sensor_x_name',
              },
              {
                intervalType: 'COLUMN-VALUE',
                columnName: 'sensor_y_name',
              },
            ],
          },
          tagSources: {},
          upstreamLineage: [
            {
              createdAt: 1772155964141,
              updatedBy: 'jaejun.lee',
              fromEntity: {
                id: 'edc02995-5f17-4337-bf68-1f1cc50de439',
                fullyQualifiedName: 'bronze-iceberg.bronze.g_turbo.hanwha_impact_bearings1',
                type: 'table',
                fqnHash:
                  'd3e099f4de5c79f8999f7fccaf37c881.cab7e764b30007514145eaf2f6a7ed0f.5df9be687e674cc4273916ac1fa9a834.a66e61c366324ca6e515d8afbf21c9ad',
              },
              createdBy: 'jaejun.lee',
              docId:
                'bronze-iceberg.bronze.g_turbo.hanwha_impact_bearings1--->silver-iceberg.silver.g_turbo.hanwha_impact_config',
              docUniqueId: 'edc02995-5f17-4337-bf68-1f1cc50de439--->45ae3a26-7cce-45d6-abea-45c9cd8d43c2',
              source: 'Manual',
              updatedAt: 1772155964141,
            },
          ],
          locationPath: null,
          fqnParts: [
            'g_turbo',
            'silver-iceberg.silver',
            'silver-iceberg.silver.g_turbo.hanwha_impact_config',
            'g_turbo.hanwha_impact_config',
            'silver-iceberg.silver.g_turbo',
            'silver.g_turbo.hanwha_impact_config',
            'silver.g_turbo',
            'silver',
            'silver-iceberg',
          ],
        },
        sort: [0],
      },
      {
        _index: 'table_search_index',
        _id: 'ca1c2aeb-84cb-4186-8686-620d7c5bcc4f',
        _score: null,
        _source: {
          databaseSchema: {
            deleted: false,
            displayName: 'g_turbo',
            name: 'g_turbo',
            description:
              '<ul class="om-list-disc"><li class="om-leading-normal"><p>가디원 터보 Iceberg 표준화 &amp; 정제를 거친 데이터 마트</p></li></ul><p></p>',
            id: '02c1fd51-c6cd-45a8-9e52-fca1044cee0a',
            type: 'databaseSchema',
            fullyQualifiedName: 'silver-iceberg.silver.g_turbo',
          },
          serviceType: 'Iceberg',
          displayName: 'kmp_ecms_config',
          schemaDefinition: null,
          description:
            '<ul class="om-list-disc"><li class="om-leading-normal"><p>KMP 신보령 대상 표준화-정제를 거친 진단 config</p></li></ul><p></p>',
          owners: [
            {
              deleted: false,
              displayName: 'DI',
              inherited: true,
              name: 'DI',
              description:
                '<ul class="om-list-disc"><li class="om-leading-normal"><p>데이터 과학자, 분석가 소속 팀</p></li></ul><p></p>',
              id: '3b28a5be-4517-48f0-84f4-01ae147493bd',
              type: 'team',
              fullyQualifiedName: 'DI',
            },
          ],
          tierSources: {},
          fqnHash:
            '655f8a2d535e8834f62cae4d39557265.97f014516561ef487ec368d6158eb3f4.5df9be687e674cc4273916ac1fa9a834.eb7c4bbbdca2f7f30a45039f4a5377c5',
          customMetrics: [],
          tableType: 'Regular',
          database: {
            deleted: false,
            displayName: 'silver',
            name: 'silver',
            id: '6bcf4d50-3c8d-4bfe-a60f-75dbee8b6478',
            type: 'database',
            fullyQualifiedName: 'silver-iceberg.silver',
          },
          descriptionStatus: 'COMPLETE',
          columnNames: [
            'id',
            'sensor_x_name',
            'sensor_y_name',
            'neighbor_id',
            'sensor_x',
            'sensor_y',
            'asset_sequence',
            'vib_threshold_h',
            'vib_threshold_hh',
            'process_temperature',
            'temperature_threshold_h',
            'temperature_threshold_hh',
            'critical_speed',
            'rated_speed',
            'source_unit',
          ],
          tier: null,
          totalVotes: 0,
          usageSummary: {
            date: '2026-03-26',
            weeklyStats: {
              percentileRank: 0,
              count: 0,
            },
            monthlyStats: {
              percentileRank: 0,
              count: 0,
            },
            dailyStats: {
              percentileRank: 0,
              count: 0,
            },
          },
          id: 'ca1c2aeb-84cb-4186-8686-620d7c5bcc4f',
          columnDescriptionStatus: 'INCOMPLETE',
          upstreamEntityRelationship: [],
          updatedAt: 1764057466011,
          columnNamesFuzzy:
            'id sensor_x_name sensor_y_name neighbor_id sensor_x sensor_y asset_sequence vib_threshold_h vib_threshold_hh process_temperature temperature_threshold_h temperature_threshold_hh critical_speed rated_speed source_unit',
          descriptionSources: {
            Manual: 1,
          },
          updatedBy: 'jaejun.lee',
          entityType: 'table',
          domains: [
            {
              displayName: 'test-production',
              inherited: true,
              name: 'test-production',
              description: '<pre><code>test-production</code></pre><p></p>',
              id: '1138eeb2-02fd-49d2-95fd-9f053348e281',
              type: 'domain',
              fullyQualifiedName: 'test-production',
            },
          ],
          dataProducts: [],
          fullyQualifiedName: 'silver-iceberg.silver.g_turbo.kmp_ecms_config',
          version: 0.2,
          queries: [],
          certification: {
            tagLabel: {
              tagFQN: 'Certification.Silver',
              name: 'Silver',
              labelType: 'Manual',
              description: 'Silver certified Data Asset',
              style: {
                color: '#B8B8B8',
                iconURL: 'SilverCertification.svg',
              },
              source: 'Classification',
              state: 'Confirmed',
            },
          },
          tags: [
            {
              tagFQN: 'Equipment Type.터빈',
              name: '터빈',
              displayName: '터빈',
              description: '터빈 설비 관련 데이터',
              source: 'Classification',
              labelType: 'Manual',
              state: 'Confirmed',
            },
            {
              tagFQN: 'Equipment Type.Furnace',
              name: 'Furnace',
              displayName: 'Furnace',
              description: '용광로 설비 관련 데이터',
              source: 'Classification',
              labelType: 'Manual',
              state: 'Confirmed',
            },
          ],
          terms: [
            {
              id: 'term-metadata',
              type: 'glossaryTerm',
              name: 'Metadata',
              displayName: '메타데이터',
              fullyQualifiedName: 'DataManagement.Metadata',
              deleted: false,
            },
            {
              id: 'term-bearing',
              type: 'glossaryTerm',
              name: 'Bearing',
              displayName: '베어링',
              fullyQualifiedName: 'Manufacturing.Bearing',
              deleted: false,
            },
          ],
          sourceHash: '1ba6c9fe5a76193d93cae2735773f81c',
          followers: [],
          deleted: false,
          service: {
            deleted: false,
            displayName: 'silver-iceberg',
            name: 'silver-iceberg',
            description:
              '<ul class="om-list-disc"><li class="om-leading-normal"><p>Silver Tier Iceberg</p></li></ul><p></p>',
            id: 'c3c00286-ae2f-4655-a827-a39a02303b36',
            type: 'databaseService',
            fullyQualifiedName: 'silver-iceberg',
          },
          name: 'kmp_ecms_config',
          processedLineage: false,
          tagSources: {},
          upstreamLineage: [
            {
              createdAt: 1768881208790,
              updatedBy: 'jaejun.lee',
              fromEntity: {
                id: '9bd93c80-515e-469d-b18d-692f09988315',
                fullyQualifiedName: 'bronze-iceberg.bronze.g_turbo.kmp_ecms_bearings1',
                type: 'table',
                fqnHash:
                  'd3e099f4de5c79f8999f7fccaf37c881.cab7e764b30007514145eaf2f6a7ed0f.5df9be687e674cc4273916ac1fa9a834.8177d2d0976ca6740ff13858f327c01b',
              },
              createdBy: 'jaejun.lee',
              docId:
                'bronze-iceberg.bronze.g_turbo.kmp_ecms_bearings1--->silver-iceberg.silver.g_turbo.kmp_ecms_config',
              docUniqueId: '9bd93c80-515e-469d-b18d-692f09988315--->ca1c2aeb-84cb-4186-8686-620d7c5bcc4f',
              source: 'Manual',
              updatedAt: 1768881208790,
            },
          ],
          locationPath: null,
          fqnParts: [
            'g_turbo',
            'silver-iceberg.silver',
            'silver-iceberg.silver.g_turbo',
            'silver-iceberg.silver.g_turbo.kmp_ecms_config',
            'silver.g_turbo',
            'silver',
            'silver.g_turbo.kmp_ecms_config',
            'g_turbo.kmp_ecms_config',
            'silver-iceberg',
          ],
        },
        sort: [0],
      },
      {
        _index: 'table_search_index',
        _id: 'b4ea86d4-1fc5-4580-9441-30a00e685a7c',
        _score: null,
        _source: {
          databaseSchema: {
            deleted: false,
            displayName: 'g_turbo',
            name: 'g_turbo',
            description:
              '<ul class="om-list-disc"><li class="om-leading-normal"><p>가디원 터보 Iceberg 표준화 &amp; 정제를 거친 데이터 마트</p></li></ul><p></p>',
            id: '02c1fd51-c6cd-45a8-9e52-fca1044cee0a',
            type: 'databaseSchema',
            fullyQualifiedName: 'silver-iceberg.silver.g_turbo',
          },
          serviceType: 'Iceberg',
          displayName: 'hanwha_impact_waveform_preprocessed',
          schemaDefinition: null,
          description:
            '<ul class="om-list-disc"><li class="om-leading-normal"><p>한화 임팩트 대상 표준화-정제를 거친 진동 raw 데이터</p></li></ul><p></p>',
          owners: [
            {
              deleted: false,
              displayName: 'DI',
              inherited: true,
              name: 'DI',
              description:
                '<ul class="om-list-disc"><li class="om-leading-normal"><p>데이터 과학자, 분석가 소속 팀</p></li></ul><p></p>',
              id: '3b28a5be-4517-48f0-84f4-01ae147493bd',
              type: 'team',
              fullyQualifiedName: 'DI',
            },
          ],
          tierSources: {},
          fqnHash:
            '655f8a2d535e8834f62cae4d39557265.97f014516561ef487ec368d6158eb3f4.5df9be687e674cc4273916ac1fa9a834.b48a8b54732efede02ad9df226d1bbf6',
          customMetrics: [],
          tableType: 'Regular',
          database: {
            deleted: false,
            displayName: 'silver',
            name: 'silver',
            id: '6bcf4d50-3c8d-4bfe-a60f-75dbee8b6478',
            type: 'database',
            fullyQualifiedName: 'silver-iceberg.silver',
          },
          descriptionStatus: 'COMPLETE',
          columnNames: [
            'acquisition_time',
            'enterprise',
            'area',
            'site',
            'process',
            'unit',
            'component',
            'component_id',
            'bearing_name',
            'sensor_x_name',
            'sensor_y_name',
            'rotation_direction',
            'vibration_x',
            'vibration_y',
            'x_peak_to_peak',
            'y_peak_to_peak',
            'vibration_type',
            'sample_size',
            'sample_rate',
            'rpm',
          ],
          tier: null,
          totalVotes: 0,
          usageSummary: {
            date: '2026-03-26',
            weeklyStats: {
              percentileRank: 0,
              count: 0,
            },
            monthlyStats: {
              percentileRank: 0,
              count: 0,
            },
            dailyStats: {
              percentileRank: 0,
              count: 0,
            },
          },
          id: 'b4ea86d4-1fc5-4580-9441-30a00e685a7c',
          columnDescriptionStatus: 'COMPLETE',
          upstreamEntityRelationship: [],
          updatedAt: 1761899149915,
          columnNamesFuzzy:
            'acquisition_time enterprise area site process unit component component_id bearing_name sensor_x_name sensor_y_name rotation_direction vibration_x vibration_y x_peak_to_peak y_peak_to_peak vibration_type sample_size sample_rate rpm',
          descriptionSources: {
            Manual: 21,
          },
          updatedBy: 'jaejun.lee',
          entityType: 'table',
          domains: [
            {
              displayName: 'test-production',
              inherited: true,
              name: 'test-production',
              description: '<pre><code>test-production</code></pre><p></p>',
              id: '1138eeb2-02fd-49d2-95fd-9f053348e281',
              type: 'domain',
              fullyQualifiedName: 'test-production',
            },
          ],
          dataProducts: [],
          fullyQualifiedName: 'silver-iceberg.silver.g_turbo.hanwha_impact_waveform_preprocessed',
          version: 0.3,
          queries: [],
          certification: {
            tagLabel: {
              tagFQN: 'Certification.Silver',
              name: 'Silver',
              labelType: 'Manual',
              description: 'Silver certified Data Asset',
              style: {
                color: '#B8B8B8',
                iconURL: 'SilverCertification.svg',
              },
              source: 'Classification',
              state: 'Confirmed',
            },
          },
          tags: [
            {
              tagFQN: 'Equipment Type.Furnace',
              name: 'Furnace',
              displayName: 'Furnace',
              description: '용광로 설비 관련 데이터',
              source: 'Classification',
              labelType: 'Manual',
              state: 'Confirmed',
            },
            {
              tagFQN: 'Equipment Type.Hi-Mold',
              name: 'Hi-Mold',
              displayName: 'Hi-Mold',
              description: '하이몰드 설비 관련 데이터',
              source: 'Classification',
              labelType: 'Manual',
              state: 'Confirmed',
            },
          ],
          terms: [
            {
              id: 'term-vibration',
              type: 'glossaryTerm',
              name: 'Vibration',
              displayName: '진동',
              fullyQualifiedName: 'Manufacturing.Vibration',
              deleted: false,
            },
            {
              id: 'term-preprocessing',
              type: 'glossaryTerm',
              name: 'Preprocessing',
              displayName: '전처리',
              fullyQualifiedName: 'DataManagement.Preprocessing',
              deleted: false,
            },
          ],
          sourceHash: '6f3e854ff0e53b78b601ff4eee236dea',
          followers: [],
          deleted: false,
          service: {
            deleted: false,
            displayName: 'silver-iceberg',
            name: 'silver-iceberg',
            description:
              '<ul class="om-list-disc"><li class="om-leading-normal"><p>Silver Tier Iceberg</p></li></ul><p></p>',
            id: 'c3c00286-ae2f-4655-a827-a39a02303b36',
            type: 'databaseService',
            fullyQualifiedName: 'silver-iceberg',
          },
          name: 'hanwha_impact_waveform_preprocessed',
          processedLineage: false,
          tablePartition: {
            columns: [
              {
                intervalType: 'COLUMN-VALUE',
                columnName: 'sensor_x_name',
              },
              {
                intervalType: 'COLUMN-VALUE',
                columnName: 'sensor_y_name',
              },
            ],
          },
          tagSources: {},
          upstreamLineage: [
            {
              createdAt: 1772155943328,
              updatedBy: 'jaejun.lee',
              fromEntity: {
                id: 'd1d8059f-682e-40a1-bd26-3de2ef111757',
                fullyQualifiedName: 'bronze-iceberg.bronze.g_turbo.hanwha_impact_chart',
                type: 'table',
                fqnHash:
                  'd3e099f4de5c79f8999f7fccaf37c881.cab7e764b30007514145eaf2f6a7ed0f.5df9be687e674cc4273916ac1fa9a834.4f6b85d9e5c59680a3ced32f7efcadde',
              },
              createdBy: 'jaejun.lee',
              docId:
                'bronze-iceberg.bronze.g_turbo.hanwha_impact_chart--->silver-iceberg.silver.g_turbo.hanwha_impact_waveform_preprocessed',
              docUniqueId: 'd1d8059f-682e-40a1-bd26-3de2ef111757--->b4ea86d4-1fc5-4580-9441-30a00e685a7c',
              source: 'Manual',
              updatedAt: 1772155943328,
            },
            {
              createdAt: 1772155959218,
              updatedBy: 'jaejun.lee',
              fromEntity: {
                id: 'e796067f-ea82-4045-90b0-b0818ce60132',
                fullyQualifiedName: 'bronze-iceberg.bronze.g_turbo.hanwha_impact_trend',
                type: 'table',
                fqnHash:
                  'd3e099f4de5c79f8999f7fccaf37c881.cab7e764b30007514145eaf2f6a7ed0f.5df9be687e674cc4273916ac1fa9a834.e4da57ff8388af16c105ca22295063be',
              },
              createdBy: 'jaejun.lee',
              docId:
                'bronze-iceberg.bronze.g_turbo.hanwha_impact_trend--->silver-iceberg.silver.g_turbo.hanwha_impact_waveform_preprocessed',
              docUniqueId: 'e796067f-ea82-4045-90b0-b0818ce60132--->b4ea86d4-1fc5-4580-9441-30a00e685a7c',
              source: 'Manual',
              updatedAt: 1772155959218,
            },
            {
              createdAt: 1772155946229,
              updatedBy: 'jaejun.lee',
              fromEntity: {
                id: 'edc02995-5f17-4337-bf68-1f1cc50de439',
                fullyQualifiedName: 'bronze-iceberg.bronze.g_turbo.hanwha_impact_bearings1',
                type: 'table',
                fqnHash:
                  'd3e099f4de5c79f8999f7fccaf37c881.cab7e764b30007514145eaf2f6a7ed0f.5df9be687e674cc4273916ac1fa9a834.a66e61c366324ca6e515d8afbf21c9ad',
              },
              createdBy: 'jaejun.lee',
              docId:
                'bronze-iceberg.bronze.g_turbo.hanwha_impact_bearings1--->silver-iceberg.silver.g_turbo.hanwha_impact_waveform_preprocessed',
              docUniqueId: 'edc02995-5f17-4337-bf68-1f1cc50de439--->b4ea86d4-1fc5-4580-9441-30a00e685a7c',
              source: 'Manual',
              updatedAt: 1772155946229,
            },
          ],
          locationPath: null,
          fqnParts: [
            'silver.g_turbo.hanwha_impact_waveform_preprocessed',
            'g_turbo',
            'silver-iceberg.silver',
            'g_turbo.hanwha_impact_waveform_preprocessed',
            'silver-iceberg.silver.g_turbo',
            'silver.g_turbo',
            'silver',
            'silver-iceberg',
            'silver-iceberg.silver.g_turbo.hanwha_impact_waveform_preprocessed',
          ],
        },
        sort: [0],
      },
      {
        _index: 'table_search_index',
        _id: '12b2fbff-74e4-4a77-845f-b81370f18b18',
        _score: null,
        _source: {
          databaseSchema: {
            deleted: false,
            displayName: 'g_turbo',
            name: 'g_turbo',
            description:
              '<ul class="om-list-disc"><li class="om-leading-normal"><p>가디원 터보 Iceberg 표준화 &amp; 정제를 거친 데이터 마트</p></li></ul><p></p>',
            id: '02c1fd51-c6cd-45a8-9e52-fca1044cee0a',
            type: 'databaseSchema',
            fullyQualifiedName: 'silver-iceberg.silver.g_turbo',
          },
          serviceType: 'Iceberg',
          displayName: 'gsp_ecms1_config',
          schemaDefinition: null,
          description:
            '<ul class="om-list-disc"><li class="om-leading-normal"><p>GSP ECMS1 대상 표준화-정제를 거친 진단 config</p></li></ul><p></p>',
          owners: [
            {
              deleted: false,
              displayName: 'DI',
              inherited: true,
              name: 'DI',
              description:
                '<ul class="om-list-disc"><li class="om-leading-normal"><p>데이터 과학자, 분석가 소속 팀</p></li></ul><p></p>',
              id: '3b28a5be-4517-48f0-84f4-01ae147493bd',
              type: 'team',
              fullyQualifiedName: 'DI',
            },
          ],
          tierSources: {},
          fqnHash:
            '655f8a2d535e8834f62cae4d39557265.97f014516561ef487ec368d6158eb3f4.5df9be687e674cc4273916ac1fa9a834.f4a9ee0403e90e3be45fe1804ca0a72e',
          customMetrics: [],
          tableType: 'Regular',
          database: {
            deleted: false,
            displayName: 'silver',
            name: 'silver',
            id: '6bcf4d50-3c8d-4bfe-a60f-75dbee8b6478',
            type: 'database',
            fullyQualifiedName: 'silver-iceberg.silver',
          },
          descriptionStatus: 'COMPLETE',
          columnNames: [
            'id',
            'sensor_x_name',
            'sensor_y_name',
            'neighbor_id',
            'sensor_x',
            'sensor_y',
            'asset_sequence',
            'vib_threshold_h',
            'vib_threshold_hh',
            'process_temperature',
            'temperature_threshold_h',
            'temperature_threshold_hh',
            'critical_speed',
            'rated_speed',
            'source_unit',
          ],
          tier: null,
          totalVotes: 0,
          usageSummary: {
            date: '2026-03-26',
            weeklyStats: {
              percentileRank: 0,
              count: 0,
            },
            monthlyStats: {
              percentileRank: 0,
              count: 0,
            },
            dailyStats: {
              percentileRank: 0,
              count: 0,
            },
          },
          id: '12b2fbff-74e4-4a77-845f-b81370f18b18',
          columnDescriptionStatus: 'INCOMPLETE',
          upstreamEntityRelationship: [],
          updatedAt: 1760666466471,
          columnNamesFuzzy:
            'id sensor_x_name sensor_y_name neighbor_id sensor_x sensor_y asset_sequence vib_threshold_h vib_threshold_hh process_temperature temperature_threshold_h temperature_threshold_hh critical_speed rated_speed source_unit',
          descriptionSources: {
            Manual: 15,
          },
          updatedBy: 'jaejun.lee',
          entityType: 'table',
          domains: [
            {
              displayName: 'test-production',
              inherited: true,
              name: 'test-production',
              description: '<pre><code>test-production</code></pre><p></p>',
              id: '1138eeb2-02fd-49d2-95fd-9f053348e281',
              type: 'domain',
              fullyQualifiedName: 'test-production',
            },
          ],
          dataProducts: [],
          fullyQualifiedName: 'silver-iceberg.silver.g_turbo.gsp_ecms1_config',
          version: 0.3,
          queries: [],
          certification: {
            tagLabel: {
              tagFQN: 'Certification.Silver',
              name: 'Silver',
              labelType: 'Manual',
              description: 'Silver certified Data Asset',
              style: {
                color: '#B8B8B8',
                iconURL: 'SilverCertification.svg',
              },
              source: 'Classification',
              state: 'Confirmed',
            },
          },
          tags: [
            {
              tagFQN: 'Equipment Type.CNC_Lathe',
              name: 'CNC_Lathe',
              displayName: 'CNC Lathe',
              description: 'CNC 선반 설비 관련 데이터',
              source: 'Classification',
              labelType: 'Manual',
              state: 'Confirmed',
            },
            {
              tagFQN: 'Equipment Type.터빈',
              name: '터빈',
              displayName: '터빈',
              description: '터빈 설비 관련 데이터',
              source: 'Classification',
              labelType: 'Manual',
              state: 'Confirmed',
            },
          ],
          terms: [
            {
              id: 'term-metadata',
              type: 'glossaryTerm',
              name: 'Metadata',
              displayName: '메타데이터',
              fullyQualifiedName: 'DataManagement.Metadata',
              deleted: false,
            },
          ],
          sourceHash: '950d75191decea1fbb1afda4dbd6ef3f',
          followers: [],
          deleted: false,
          service: {
            deleted: false,
            displayName: 'silver-iceberg',
            name: 'silver-iceberg',
            description:
              '<ul class="om-list-disc"><li class="om-leading-normal"><p>Silver Tier Iceberg</p></li></ul><p></p>',
            id: 'c3c00286-ae2f-4655-a827-a39a02303b36',
            type: 'databaseService',
            fullyQualifiedName: 'silver-iceberg',
          },
          name: 'gsp_ecms1_config',
          processedLineage: false,
          tablePartition: {
            columns: [
              {
                intervalType: 'COLUMN-VALUE',
                columnName: 'sensor_x_name',
              },
              {
                intervalType: 'COLUMN-VALUE',
                columnName: 'sensor_y_name',
              },
            ],
          },
          tagSources: {},
          upstreamLineage: [
            {
              createdAt: 1772155664546,
              updatedBy: 'jaejun.lee',
              fromEntity: {
                id: 'c71b5d60-f057-404b-aba7-e6e6d6f385ed',
                fullyQualifiedName: 'bronze-iceberg.bronze.g_turbo.gsp_ecms1_bearings1',
                type: 'table',
                fqnHash:
                  'd3e099f4de5c79f8999f7fccaf37c881.cab7e764b30007514145eaf2f6a7ed0f.5df9be687e674cc4273916ac1fa9a834.ae65a7f74d9dd2785698b81c39b3aedb',
              },
              createdBy: 'jaejun.lee',
              docId:
                'bronze-iceberg.bronze.g_turbo.gsp_ecms1_bearings1--->silver-iceberg.silver.g_turbo.gsp_ecms1_config',
              docUniqueId: 'c71b5d60-f057-404b-aba7-e6e6d6f385ed--->12b2fbff-74e4-4a77-845f-b81370f18b18',
              source: 'Manual',
              updatedAt: 1772155664546,
            },
          ],
          locationPath: null,
          fqnParts: [
            'g_turbo.gsp_ecms1_config',
            'silver.g_turbo.gsp_ecms1_config',
            'g_turbo',
            'silver-iceberg.silver',
            'silver-iceberg.silver.g_turbo.gsp_ecms1_config',
            'silver-iceberg.silver.g_turbo',
            'silver.g_turbo',
            'silver',
            'silver-iceberg',
          ],
        },
        sort: [0],
      },
      {
        _index: 'table_search_index',
        _id: '30d3a43b-7036-4911-8626-69904bec7dbd',
        _score: null,
        _source: {
          databaseSchema: {
            deleted: false,
            displayName: 'g_turbo',
            name: 'g_turbo',
            description:
              '<ul class="om-list-disc"><li class="om-leading-normal"><p>가디원 터보 Iceberg 표준화 &amp; 정제를 거친 데이터 마트</p></li></ul><p></p>',
            id: '02c1fd51-c6cd-45a8-9e52-fca1044cee0a',
            type: 'databaseSchema',
            fullyQualifiedName: 'silver-iceberg.silver.g_turbo',
          },
          serviceType: 'Iceberg',
          displayName: 'kmp_ecms_waveform_preprocessed',
          schemaDefinition: null,
          description:
            '<ul class="om-list-disc"><li class="om-leading-normal"><p>KMP 신보령 대상 표준화-정제를 거친 진동 raw 데이터</p></li></ul><p></p>',
          owners: [
            {
              deleted: false,
              displayName: 'DI',
              inherited: true,
              name: 'DI',
              description:
                '<ul class="om-list-disc"><li class="om-leading-normal"><p>데이터 과학자, 분석가 소속 팀</p></li></ul><p></p>',
              id: '3b28a5be-4517-48f0-84f4-01ae147493bd',
              type: 'team',
              fullyQualifiedName: 'DI',
            },
          ],
          tierSources: {},
          fqnHash:
            '655f8a2d535e8834f62cae4d39557265.97f014516561ef487ec368d6158eb3f4.5df9be687e674cc4273916ac1fa9a834.a085a82b4e6c8fa8b2514053778bb175',
          customMetrics: [],
          tableType: 'Regular',
          database: {
            deleted: false,
            displayName: 'silver',
            name: 'silver',
            id: '6bcf4d50-3c8d-4bfe-a60f-75dbee8b6478',
            type: 'database',
            fullyQualifiedName: 'silver-iceberg.silver',
          },
          descriptionStatus: 'COMPLETE',
          columnNames: [
            'acquisition_time',
            'enterprise',
            'area',
            'site',
            'process',
            'unit',
            'component',
            'component_id',
            'bearing_name',
            'sensor_x_name',
            'sensor_y_name',
            'rotation_direction',
            'vibration_x',
            'vibration_y',
            'x_peak_to_peak',
            'y_peak_to_peak',
            'vibration_type',
            'sample_size',
            'sample_rate',
            'rpm',
          ],
          tier: null,
          totalVotes: 0,
          usageSummary: {
            date: '2026-03-26',
            weeklyStats: {
              percentileRank: 0,
              count: 0,
            },
            monthlyStats: {
              percentileRank: 0,
              count: 0,
            },
            dailyStats: {
              percentileRank: 0,
              count: 0,
            },
          },
          id: '30d3a43b-7036-4911-8626-69904bec7dbd',
          columnDescriptionStatus: 'INCOMPLETE',
          upstreamEntityRelationship: [],
          updatedAt: 1764057443708,
          columnNamesFuzzy:
            'acquisition_time enterprise area site process unit component component_id bearing_name sensor_x_name sensor_y_name rotation_direction vibration_x vibration_y x_peak_to_peak y_peak_to_peak vibration_type sample_size sample_rate rpm',
          descriptionSources: {
            Manual: 1,
          },
          updatedBy: 'jaejun.lee',
          entityType: 'table',
          domains: [
            {
              displayName: 'test-production',
              inherited: true,
              name: 'test-production',
              description: '<pre><code>test-production</code></pre><p></p>',
              id: '1138eeb2-02fd-49d2-95fd-9f053348e281',
              type: 'domain',
              fullyQualifiedName: 'test-production',
            },
          ],
          dataProducts: [],
          fullyQualifiedName: 'silver-iceberg.silver.g_turbo.kmp_ecms_waveform_preprocessed',
          version: 0.2,
          queries: [],
          certification: {
            tagLabel: {
              tagFQN: 'Certification.Silver',
              name: 'Silver',
              labelType: 'Manual',
              description: 'Silver certified Data Asset',
              style: {
                color: '#B8B8B8',
                iconURL: 'SilverCertification.svg',
              },
              source: 'Classification',
              state: 'Confirmed',
            },
          },
          tags: [],
          terms: [
            {
              id: 'term-preprocessing',
              type: 'glossaryTerm',
              name: 'Preprocessing',
              displayName: '전처리',
              fullyQualifiedName: 'DataManagement.Preprocessing',
              deleted: false,
            },
            {
              id: 'term-vibration',
              type: 'glossaryTerm',
              name: 'Vibration',
              displayName: '진동',
              fullyQualifiedName: 'Manufacturing.Vibration',
              deleted: false,
            },
          ],
          sourceHash: '73e4fc85cc8cb7bf585f87f99a4faab8',
          followers: [],
          deleted: false,
          service: {
            deleted: false,
            displayName: 'silver-iceberg',
            name: 'silver-iceberg',
            description:
              '<ul class="om-list-disc"><li class="om-leading-normal"><p>Silver Tier Iceberg</p></li></ul><p></p>',
            id: 'c3c00286-ae2f-4655-a827-a39a02303b36',
            type: 'databaseService',
            fullyQualifiedName: 'silver-iceberg',
          },
          name: 'kmp_ecms_waveform_preprocessed',
          processedLineage: false,
          tagSources: {},
          upstreamLineage: [
            {
              createdAt: 1772156124227,
              updatedBy: 'jaejun.lee',
              fromEntity: {
                id: '0abb6d20-9e11-40fd-8ff1-b7edefcce0e3',
                fullyQualifiedName: 'bronze-iceberg.bronze.g_turbo.kmp_ecms_chart',
                type: 'table',
                fqnHash:
                  'd3e099f4de5c79f8999f7fccaf37c881.cab7e764b30007514145eaf2f6a7ed0f.5df9be687e674cc4273916ac1fa9a834.7710d2797576f72765e7f35d96948e08',
              },
              createdBy: 'jaejun.lee',
              docId:
                'bronze-iceberg.bronze.g_turbo.kmp_ecms_chart--->silver-iceberg.silver.g_turbo.kmp_ecms_waveform_preprocessed',
              docUniqueId: '0abb6d20-9e11-40fd-8ff1-b7edefcce0e3--->30d3a43b-7036-4911-8626-69904bec7dbd',
              source: 'Manual',
              updatedAt: 1772156124227,
            },
            {
              createdAt: 1772156128765,
              updatedBy: 'jaejun.lee',
              fromEntity: {
                id: '3c18c183-3c0e-4f2a-8b02-09785dac0683',
                fullyQualifiedName: 'bronze-iceberg.bronze.g_turbo.kmp_ecms_trend',
                type: 'table',
                fqnHash:
                  'd3e099f4de5c79f8999f7fccaf37c881.cab7e764b30007514145eaf2f6a7ed0f.5df9be687e674cc4273916ac1fa9a834.c812a2fe95072f58adba38c70fc5c817',
              },
              createdBy: 'jaejun.lee',
              docId:
                'bronze-iceberg.bronze.g_turbo.kmp_ecms_trend--->silver-iceberg.silver.g_turbo.kmp_ecms_waveform_preprocessed',
              docUniqueId: '3c18c183-3c0e-4f2a-8b02-09785dac0683--->30d3a43b-7036-4911-8626-69904bec7dbd',
              source: 'Manual',
              updatedAt: 1772156128765,
            },
            {
              createdAt: 1772156134084,
              updatedBy: 'jaejun.lee',
              fromEntity: {
                id: '9bd93c80-515e-469d-b18d-692f09988315',
                fullyQualifiedName: 'bronze-iceberg.bronze.g_turbo.kmp_ecms_bearings1',
                type: 'table',
                fqnHash:
                  'd3e099f4de5c79f8999f7fccaf37c881.cab7e764b30007514145eaf2f6a7ed0f.5df9be687e674cc4273916ac1fa9a834.8177d2d0976ca6740ff13858f327c01b',
              },
              createdBy: 'jaejun.lee',
              docId:
                'bronze-iceberg.bronze.g_turbo.kmp_ecms_bearings1--->silver-iceberg.silver.g_turbo.kmp_ecms_waveform_preprocessed',
              docUniqueId: '9bd93c80-515e-469d-b18d-692f09988315--->30d3a43b-7036-4911-8626-69904bec7dbd',
              source: 'Manual',
              updatedAt: 1772156134084,
            },
          ],
          locationPath: null,
          fqnParts: [
            'g_turbo',
            'silver-iceberg.silver',
            'g_turbo.kmp_ecms_waveform_preprocessed',
            'silver-iceberg.silver.g_turbo.kmp_ecms_waveform_preprocessed',
            'silver.g_turbo.kmp_ecms_waveform_preprocessed',
            'silver-iceberg.silver.g_turbo',
            'silver.g_turbo',
            'silver',
            'silver-iceberg',
          ],
        },
        sort: [0],
      },
    ],
  },
  aggregations: {
    'sterms#serviceType': {
      doc_count_error_upper_bound: 0,
      sum_other_doc_count: 0,
      buckets: [
        {
          key: 'iceberg',
          doc_count: 6,
        },
      ],
    },
    'sterms#databaseSchema.name.keyword': {
      doc_count_error_upper_bound: 0,
      sum_other_doc_count: 0,
      buckets: [
        {
          key: 'g_turbo',
          doc_count: 6,
        },
      ],
    },
    'sterms#tags.tagFQN': {
      doc_count_error_upper_bound: 0,
      sum_other_doc_count: 0,
      buckets: [],
    },
    'sterms#databaseSchema.displayName': {
      doc_count_error_upper_bound: 0,
      sum_other_doc_count: 0,
      buckets: [
        {
          key: 'g_turbo',
          doc_count: 6,
        },
      ],
    },
    'sterms#entityType': {
      doc_count_error_upper_bound: 0,
      sum_other_doc_count: 0,
      buckets: [
        {
          key: 'table',
          doc_count: 6,
        },
      ],
    },
    'sterms#entityType.keyword': {
      doc_count_error_upper_bound: 0,
      sum_other_doc_count: 0,
      buckets: [
        {
          key: 'table',
          doc_count: 6,
        },
      ],
    },
    'sterms#domain.displayName.keyword': {
      doc_count_error_upper_bound: 0,
      sum_other_doc_count: 0,
      buckets: [],
    },
    'sterms#tier.tagFQN': {
      doc_count_error_upper_bound: 0,
      sum_other_doc_count: 0,
      buckets: [],
    },
    'sterms#service.displayName.keyword': {
      doc_count_error_upper_bound: 0,
      sum_other_doc_count: 0,
      buckets: [
        {
          key: 'silver-iceberg',
          doc_count: 6,
        },
      ],
    },
    'sterms#database.displayName': {
      doc_count_error_upper_bound: 0,
      sum_other_doc_count: 0,
      buckets: [
        {
          key: 'silver',
          doc_count: 6,
        },
      ],
    },
    'sterms#database.name.keyword': {
      doc_count_error_upper_bound: 0,
      sum_other_doc_count: 0,
      buckets: [
        {
          key: 'silver',
          doc_count: 6,
        },
      ],
    },
    'sterms#certification.tagLabel.tagFQN': {
      doc_count_error_upper_bound: 0,
      sum_other_doc_count: 0,
      buckets: [],
    },
    'sterms#owners.displayName.keyword': {
      doc_count_error_upper_bound: 0,
      sum_other_doc_count: 0,
      buckets: [
        {
          key: 'di',
          doc_count: 6,
        },
      ],
    },
  },
};
